import React from "react";
import WhyUs from "./WhyUs";
import style from "./css/OurCourse.module.css";
import file from "../All Course Syllabus.pdf";
import ContactUs from "./ContactUs";
import { Link } from "react-router-dom";
import WhatsApp from "./WhatsApp";
function OurCourse() {
  document.title = "Sky Computer Education | Our Courses";
  const course = [
    {
      id: 1,
      heading: "DCA",
      discription: "3 Month with Certificate",
      link: "",
    },
    {
      id: 2,
      heading: "DOA/DFA",
      discription: "6 Month with Certificate",
      link: "",
    },
    {
      id: 3,
      heading: "ADCA",
      discription: "1 Year with Certificate",
      link: "",
    },
    {
      id: 4,
      heading: "Tally",
      discription: "2 Month with Certificate",
      link: "",
    },
    {
      id: 5,
      heading: "GRAPHIC DESIGN / DTP",
      discription: "3 Month with Certificate",
      link: "",
    },
    {
      id: 6,
      heading: "DIGITAL MARKETING",
      discription: "6 Month with Certificate",
      link: "",
    },
    {
      id: 7,
      heading: "ADVANCE EXCEL",
      discription: "3 Month with Certificate",
      link: "",
    },
    {
      id: 8,
      heading: "FULL STACK DEVELOPMENT",
      discription: "1 Year with Certificate",
      link: "",
    },
    {
      id: 9,
      heading: "Marge ERP 9+",
      discription: "6 Month with Certificate",
      link: "",
    },
    {
      id: 10,
      heading: "UI/UX DESIGN",
      discription: "3 Month with Certificate",
      link: "",
    },
    {
      id: 11,
      heading: "VIDEO EDITING",
      discription: "3 Month with Certificate",
      link: "",
    },
    {
      id: 12,
      heading: "OTHERS",
      discription: "With Certificate",
      link: "",
    },
  ];
  return (
    <>
      <div className={style.courses}>
        <h2 className="text-center text-warning p-2"> Our Courses</h2>
        <div className={`${style.our_courses} container`}>
          {course.map((e) => (
            <div className={`${style.course_box} col-lg`} key={e.id}>
              <h3>{e.heading}</h3>
              <span>{e.discription}</span>
              <button className="btn btn-sm">
                <Link to={e.link}>More Details</Link>{" "}
              </button>
            </div>
          ))}
          <button className="btn btn-sm btn-danger mt-4">
            <a href={file} download className="text-light text-decoration-none">
              Download All Course Syllabus
            </a>
          </button>
        </div>
      </div>
      <WhyUs />
      <ContactUs />
      <WhatsApp />
    </>
  );
}

export default OurCourse;



